import { useEffect, useState } from 'react';
import { Box, Text } from '@atlaskit/primitives';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@app/providers/query-client';
import { ThemeProvider } from '@app/providers/ThemeProvider';
import { router } from '@app/routing/router';
import { store } from '@shared/store';
import { login, logout } from '@shared/store/exchangeSlice';
import { handleValidateToken } from '@shared/lib/auth';
import '@atlaskit/css-reset';
import { preloadInventoryState } from '@shared/lib/inventory';

function App() {
  const [isBootstrappingAuth, setIsBootstrappingAuth] = useState(true);

  useEffect(() => {
    const bootstrapAuth = async () => {
      try {
        await handleValidateToken((isLoggedIn) => {
          if (isLoggedIn) {
            store.dispatch(login());
          } else {
            store.dispatch(logout());
          }
        });

        if (store.getState().exchange.isAuthenticated) {
          const { userType, orgId } = store.getState().exchange;
        
          // const [activeApps, activeDemandPartners] = await Promise.all([
          //   fetchActiveApps(),
          //   (userType === userTypes.Crackle_User || userType === userTypes.Crackle_Admin)
          //     ? fetchActiveDemandPartners()
          //     : Promise.resolve(null)
          // ]);
        
          // store.dispatch(setActiveApps(activeApps));
        
          // if (activeDemandPartners) {
          //   store.dispatch(setActiveDemandPartners(activeDemandPartners));
          // }
          await preloadInventoryState(userType, orgId);
        }
      } finally {
        setTimeout(() => setIsBootstrappingAuth(false), 500);
      }
    };

    void bootstrapAuth();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          {isBootstrappingAuth ? (
            <Box
              style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background:
                  'radial-gradient(circle at top, color-mix(in srgb, var(--app-accent) 14%, transparent), transparent 36%), var(--app-surface-subtle)'
              }}
            >
              <div className="app-loader-shell">
                <div className="app-loader-orbit">
                  <div className="app-loader-ring app-loader-ring-primary" />
                  <div className="app-loader-ring app-loader-ring-secondary" />
                  <div className="app-loader-core">
                    <span className="app-loader-dot" />
                    <span className="app-loader-dot" />
                    <span className="app-loader-dot" />
                  </div>
                </div>
                <Text weight="bold">Preparing Exchange Console</Text>
                <Text color="color.text.subtle">Restoring your session and loading inventory...</Text>
              </div>
            </Box>
          ) : (
            <RouterProvider router={router} />
          )}
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
